import input from 'src/helpers/input'

/**
 * InputPopoverMixin is to be implemented
 * onto components which use InputPopover.
 *
 * It essentially groups all the similar props and methods into one file
 */
export default {
  mixins: [input],
  props: {
    modelValue: {
      type: [Array, Object],
      default: () => {
        return []
      }
    },
    // Icon to display to left of input
    icon: {
      type: String
    },
    borderless: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    useInput: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    separator: {
      type: Boolean,
      default: false
    },
    // Allow multiple items to be selected
    multiple: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    },
    stackLabel: {
      type: Boolean,
      default: false
    },
    // Hide the selected items on this input
    // Will instead show X items counter
    hideSelected: {
      type: Boolean,
      default: false
    },
    // How to display the selected items
    // chip (inside input) or item (underneath)
    display: {
      type: String,
      default: 'chip'
    },
    // Emit @changed event X milliseconds after the input has changed
    valueDebounce: {
      type: Number,
      default: 0
    },
    // show checkbox/radio for selected option(s)
    showSelection: {
      type: Boolean,
      default: true
    },
    // On first click, hide the popup - after consecutive times multiple items can be clicked
    hideOnFirstClick: {
      type: Boolean,
      default: false
    },
    // Inject classes to the QSelect
    inputClass: {
      type: [String, Object]
    }
  },
  emits: ['clickedResult', 'removedResult', 'update:modelValue', 'changed', 'clear', 'blur', 'focus'],
  data () {
    return {
      debounceTimer: null
    }
  },
  methods: {
    onClickedResult (val, newModel) {
      this.$emit('clickedResult', val, newModel)
    },
    onRemovedResult (val) {
      this.$emit('removedResult', val)
    },
    onInput (val) {
      this.$emit('update:modelValue', val)

      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.$emit('changed')
      }, this.valueDebounce)
    },
    onClear () {
      this.$emit('clear')
    },
    onBlur () {
      this.$emit('blur')
    },
    onFocus () {
      this.$emit('focus')
    },
    focus () {
      this.$refs.popover.showPopup()
    }
  }
}
